import React from "react";

import icon from "../images/mask.svg";

import "../styles/success-fail.scss";

const SlideOutModalSuccess = ({
  onBack,
  message,
  title,
  buttonLabel,
  details,
}) => {
  const defaultTitle = "Success!";
  const defaultButtonLabel = "Back to Client Details";

  return (
    <div className="success-fail">
      <img src={icon} alt="success" />
      <h1>{title || defaultTitle}</h1>
      <div className="content">{message}</div>
      <div>{details}</div>
      <div
        style={{ cursor: "pointer" }}
        className="btn btn-default"
        onClick={onBack}
      >
        {buttonLabel || defaultButtonLabel}
      </div>
    </div>
  );
};
export default SlideOutModalSuccess;
